import { useNovaApi } from '../useNovaApi';

export const useSongDownstreamStatus = (songUuid: string) => {
  return (
    useNovaApi<Nl.Api.SongFinderItemResponse>(
      `/song/${songUuid}/downstream_status`,
    ).data?.items || []
  );
};
